import { render, staticRenderFns } from "./ForgetPW.vue?vue&type=template&id=cbc4781c&"
import script from "./ForgetPW.vue?vue&type=script&lang=js&"
export * from "./ForgetPW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports